/**
* Jump Link Content JS
* -----------------------------------------------------------------------------
*
* All the JS for the Jump Link Content component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'jump-link-content',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.jump-link-content-splide' ).length ) {
        $( '.jump-link-content-splide' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'loop',
            padding: '5rem',
            pagination: false,
            autoWidth: true,
            gap: '2rem',
          } );
          splide.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'jump-link-content', COMPONENT );
} )( app );
